import { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import styled, { ThemeContext } from 'styled-components';
import qs from 'qs';
import { renderStyledElementStyles } from '../../helpers';
import {
  SiteBuilderModule,
  StyledHeading,
  StyledParagraph,
  StyledCallToAction,
} from '../sharedComponents';
import EventTile from './EventTile';

const Wrapper = styled.div`
  ${({ theme }) => renderStyledElementStyles(theme, theme.module.dStyles)}
  ${({ theme }) => renderStyledElementStyles(theme, theme.module.vStyles)}
`;

export default function BevyModule(props) {
  const {
    section: {
      title,
      titleSize,
      text,
      link,
      categoryId: chapterId,
      numberOfEvents: pageSize,
      imageAlignment,
      displayStyle = 'DEFAULT',
    },
  } = props;

  const themeConfig = useContext(ThemeContext);
  const moduleThemeConfig = themeConfig.siteBuilderModules.bevyModule;
  const dStyles = moduleThemeConfig.displayStyles[displayStyle];
  const vStyles = moduleThemeConfig.visualStyles[displayStyle];

  const [events, setEvents] = useState([]);

  useEffect(() => {
    async function fetchEvents() {
      try {
        const query = qs.stringify({
          chapter: chapterId,
          page_size: pageSize,
          status: 'Live',
          fields: 'id,url,title,picture,start_date',
        });
        const url = `https://meetups.fanexpohq.com/api/event?${query}`;
        const response = await fetch(url);

        return await response.json();
      } catch (error) {
        console.error(error);
      }
    }

    fetchEvents().then((data) => {
      setEvents(data.results ?? []);
    });
  }, [chapterId, pageSize]);

  return (
    <SiteBuilderModule
      section={props.section}
      moduleTheme={{ dStyles, vStyles }}
    >
      <Wrapper>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-8 col-md-offset-2">
              {title && (
                <StyledHeading
                  as={titleSize}
                  content={title}
                  visualStyles={vStyles}
                />
              )}
              {text && (
                <StyledParagraph content={text} visualStyles={vStyles} />
              )}
            </div>
          </div>
          <div
            className={cn('row', {
              'center-xs': imageAlignment === 'CENTRE',
              'end-xs': imageAlignment === 'RIGHT',
            })}
          >
            {events.map((event) => (
              <div key={event.id} className="col-xs-6 col-sm-3">
                <EventTile event={event} />
              </div>
            ))}
          </div>
          {link?.type && (
            <div className="row">
              <div className="col-xs-12">
                <StyledCallToAction
                  ctaConfig={link}
                  visualStyles={vStyles}
                  {...vStyles.elements.callToAction.settings}
                />
              </div>
            </div>
          )}
        </div>
      </Wrapper>
    </SiteBuilderModule>
  );
}
